module.exports = __webpack_public_path__ + "img/Core.b95e1e73.svg";